export default __webpack_public_path__ + "media/images/casatb/polaroid_left-309d2523f3d2d950f035d6a07f8a47cc.png";